import React from 'react'
import classNames from 'classnames'
import DateTimeWarning from '@apiEnabler/ob-common/lib/view/DateTimeWarning'
import { formatStatus } from '@apiEnabler/ob-common/lib/biometric-consents'
import { formatDate } from '@apiEnabler/ob-common/lib/date-utils'

import PageHeader from './PageHeader'
import NavBar from './NavBar'

import style from './Biometrics.module.scss'

export default function Biometrics({ biometrics }) {
  return (
    <section className="js-biometrics-list">
      <PageHeader
        navbar={<NavBar />}
        title="Biometrics"
        subtitle="Customer's registered biometrics using the mobile app for approval requests"
      />
      <div className={style.sections}>
        {biometrics.size ? (
          <React.Fragment>
            <table className="zb-table ob-table zb-full-width">
              <thead>
                <tr>
                  <th className="js-created-on-heading">Created on</th>
                  <th className="js-channel-heading">Channel registered</th>
                  <th className="js-type-heading">Biometric type</th>
                  <th className="js-version-heading">Version</th>
                  <th className="js-expires-at-heading">Expires at</th>
                  <th className="js-status-heading">Status</th>
                </tr>
              </thead>
              <tbody>
                {biometrics.map((consent, index) => (
                  <tr key={index} className={`js-consent-row-${index}`}>
                    <td className="js-created-on-heading">
                      {formatDate(consent.get('createdAt'))}
                    </td>
                    <td className="js-channel-text">
                      {consent.getIn(['payload', 'channel'])}
                    </td>
                    <td className="js-type-text">
                      {consent.getIn(['payload', 'type'])}
                    </td>
                    <td className="js-version-text">
                      {consent.getIn(['payload', 'version'])}
                    </td>
                    <td className="js-expires-at-text">
                      {consent.get('expiresAt')
                        ? formatDate(consent.get('expiresAt'))
                        : 'n/a'}
                    </td>
                    <td className="js-status-text">
                      {formatStatus(consent.get('grouping'))}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <DateTimeWarning />
          </React.Fragment>
        ) : (
          <span className={classNames(style.card, 'js-no-consents-msg')}>
            Customer does not have any biometrics registered
          </span>
        )}
      </div>
    </section>
  )
}
